import React from "react";

const SectionHeading = ({ children }) => {
  return <h2 className="section-heading">{children}</h2>;
};

export default SectionHeading;
